import styled from 'styled-components';

export const InitiatedSSOLoginContainer = styled.div`
  margin-top: 5rem;
`;

export const HiddenIframe = styled.iframe`
  display: none;
`;
